__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/9d1ae25e767a9af2912b7123682109676ca4bb2c/_next/";